import { render } from "./Construction.vue?vue&type=template&id=1add4796&scoped=true"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"

import "./Construction.vue?vue&type=style&index=0&id=1add4796&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1add4796"]])

export default __exports__